(function() {
    'use strict';

    angular.module('swif.publicLightning')
    .config(['$routeProvider', 'swifPublicLightningConstant', function($routeProvider, constants) {
        $routeProvider.when(constants.intervention.routes.table_view, {
            templateUrl: 'partials/openstc/interventions_table_view.html',
            controller: 'InterventionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.intervention.resolveData();
                }]
            }
        });
        $routeProvider.when(constants.intervention.routes.explorer_view, {
            templateUrl: 'partials/openstc/interventions_explorer_view.html',
            controller: 'InterventionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.intervention.resolveData();
                }]
            }
        });
        $routeProvider.when('/public-lightning/planning', {
            templateUrl: 'partials/openstc/planning.html',
            controller: 'InterventionPlanningController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifPublicLightningService', function (service) {
                    return service.planning.resolveData();
                }]
            }
        });
    }]);
})();
